import type {PanelEntry, PanelEntryContext, PanelEntrySurface} from './types';
import {flattenPanelEntries} from './access';

export interface PanelEntryQuery {
    surface: PanelEntrySurface;
    providerId?: string;
    ctx: PanelEntryContext;
}

/** Reads the live catalog injected via command-search services. */
export const getPanelEntries = (ctx: PanelEntryContext): PanelEntry[] =>
    (ctx.services?.panelEntries as PanelEntry[] | undefined) ?? [];

/** Returns flattened, visible entries matching the query. */
export const queryPanelEntries = ({surface, providerId, ctx}: PanelEntryQuery): PanelEntry[] => {
    const flat = flattenPanelEntries(getPanelEntries(ctx), ctx, surface);

    if (!providerId) {
        return flat;
    }

    return flat.filter((entry) => entry.commandSearch?.providerId === providerId);
};
